import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MessageSquare } from 'lucide-react';

export default function FloatingFeedbackButton() {
  const navigate = useNavigate();

  return (
    <>
      {/* Mobile: Floating bubble button */}
      <button
        onClick={() => navigate('/feedback')}
        className="md:hidden fixed bottom-5 left-5 z-50 flex items-center gap-2 px-4 py-2.5 bg-white hover:bg-[#e6e7eb] text-black rounded-md border border-white shadow-[0_10px_30px_rgba(0,0,0,0.5)] transition-all duration-300 transform hover:scale-105 group"
        aria-label="Provide Feedback"
      >
        <MessageSquare className="w-4 h-4 group-hover:rotate-12 transition-transform duration-300" />
        <span className="text-sm font-medium">Feedback</span>
      </button>

      {/* Desktop: Vertical tab on right edge */}
      <button
        onClick={() => navigate('/feedback')}
        className="hidden md:flex fixed right-0 top-1/2 -translate-y-1/2 z-50 flex-row items-center gap-1 px-1.5 py-3 bg-[#0f1014] hover:bg-[#16171c] text-white/80 hover:text-white border border-r-0 border-white/15 rounded-l-md transition-all duration-300 transform hover:-translate-x-1 group"
        aria-label="Provide Feedback"
        style={{ writingMode: 'vertical-rl' }}
      >
        <span className="text-[11px] font-normal tracking-[0.12em] font-mono">FEEDBACK</span>
        <MessageSquare className="w-3.5 h-3.5 group-hover:rotate-12 transition-transform duration-300" style={{ writingMode: 'horizontal-tb' }} />
      </button>
    </>
  );
}
